import toast from 'react-hot-toast';
import { AnyAction } from 'redux';
import {
    DOWNLOAD_PROCESSED_FILES,
    DOWNLOAD_PROCESSED_FILES_FAIL,
    DOWNLOAD_PROCESSED_FILES_SUCCESS,
    GET_PROCESSED_FILES,
    GET_PROCESSED_FILES_FAIL,
    GET_PROCESSED_FILES_SUCCESS,
    VALIDATE_MOBILE_BULK,
    VALIDATE_MOBILE_BULK_FAIL,
    VALIDATE_MOBILE_BULK_RESET,
    VALIDATE_MOBILE_BULK_SUCCESS,
    VALIDATE_MOBILE_SINGLE,
    VALIDATE_MOBILE_SINGLE_FAIL,
    VALIDATE_MOBILE_SINGLE_SUCCESS,
} from './constants';
import {
    downloadProcessedFileInitialState,
    DownloadProcessedFileState,
    mobileBulkValidationInitialState,
    MobileBulkValidationState,
    mobileSingleValidationInitialState,
    MobileSingleValidationState,
    processedFilesInitialState,
    ProcessedFilesState,
} from './state';

export const mobileSingleValidationReducer = (
    state: MobileSingleValidationState = mobileSingleValidationInitialState,
    action: AnyAction
) => {
    const { payload } = action;

    switch (action.type) {
        case VALIDATE_MOBILE_SINGLE:
            return { ...state, loading: true };

        case VALIDATE_MOBILE_SINGLE_SUCCESS:
            toast.success('Request Successful');
            return { ...state, loading: false, success: true, data: payload };

        case VALIDATE_MOBILE_SINGLE_FAIL:
            toast.error('Failed on Validating Mobile!');
            return { ...state, loading: false, error: payload };

        default:
            return state;
    }
};

export const mobileBulkValidationReducer = (state: MobileBulkValidationState = mobileBulkValidationInitialState, action: AnyAction) => {
    const { payload } = action;

    switch (action.type) {
        case VALIDATE_MOBILE_BULK:
            return { ...state, loading: true };

        case VALIDATE_MOBILE_BULK_SUCCESS:
            toast.success('Upload successful! Your file is being process');
            return { ...state, loading: false, success: true, data: payload };

        case VALIDATE_MOBILE_BULK_FAIL:
            toast.error('Failed on uploading the file!');
            return { ...state, loading: false, error: payload };

        case VALIDATE_MOBILE_BULK_RESET:
            return { ...state, loading: false, success: false, error: null, data: null };

        default:
            return state;
    }
};

export const getProcessedFilesReducer = (state: ProcessedFilesState = processedFilesInitialState, action: AnyAction) => {
    const { payload } = action;

    switch (action.type) {
        case GET_PROCESSED_FILES:
            return { ...state, loading: true };

        case GET_PROCESSED_FILES_SUCCESS:
            return { ...state, loading: false, success: true, data: payload };

        case GET_PROCESSED_FILES_FAIL:
            return { ...state, loading: false, error: payload };

        default:
            return state;
    }
};

export const downloadProcessedFilesReducer = (state: DownloadProcessedFileState = downloadProcessedFileInitialState, action: AnyAction) => {
    const { payload } = action;

    switch (action.type) {
        case DOWNLOAD_PROCESSED_FILES:
            return { ...state, loading: true };

        case DOWNLOAD_PROCESSED_FILES_SUCCESS:
            return { ...state, loading: false, success: true, data: payload };

        case DOWNLOAD_PROCESSED_FILES_FAIL:
            return { ...state, loading: false, error: payload };

        default:
            return state;
    }
};
